import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardTitle } from '../../../../ui-kit';
import { Placeholder } from '../Placeholder';
import { useFromToContext } from '../../../shared';
import { DateFromTo, TopEmployeesComponent } from '../../../../generated/graphql';
import TopEmployeeCard from './TopEmployeeCard';

const TopEmployeesList = () => {
    const { t } = useTranslation();
    const { dateFromTo } = useFromToContext();

    return (
        <TopEmployeesComponent
            variables={{ dateFromTo: dateFromTo as DateFromTo }}
            fetchPolicy='network-only'
            Loader={() => <Placeholder minHeight={260} />}
        >
            {({ data: { topEmployees } }) => (
                <Card fullHeight>
                    <CardContent padding={3}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <CardTitle>{t('Top 3 employees')}</CardTitle>
                            </Grid>
                            {topEmployees.map(topEmployee => (
                                <Grid key={topEmployee.id} item xs={12} md={4}>
                                    <TopEmployeeCard {...topEmployee} />
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>
            )}
        </TopEmployeesComponent>
    );
};
export default TopEmployeesList;
